import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from './http/http.service';

@Injectable({
  providedIn: 'root'
})
export class Sh2Service {

  constructor( private httpService: HttpService) { }

     sampleShRecord(object) {
            console.log("object", object);
            var request = {
                URL: "Sh2/shEntry",
                DATA: object
        }
            return this.httpService.post(request);
    }     

    getSh2Details(object) {
        var registerList = {
                URL: "sh2/getSh2/5cee33d225242e023acfb2d4",
                DATA: object
        }
        return this.httpService.post(registerList);

    }

    removesh2details(_id){
                var request = {
                    URL: "sh2/deletadetails/" + _id 
                }
                return this.httpService.get(request);
        }

     updatesh2(_id) {
            var editlist = {
                URL: "sh2/update/" + _id,
            }
            return this.httpService.get(editlist);
        }
    
     updateSh2(object, id) {
            var request = {
                URL: "sh2/updateSh2/" +id,
                DATA: object
            }
            return this.httpService.post(request);
        }
        generateSh2Document(object) {
            var request = {
                URL: "sh2/generateSh2Document",
                DATA: object
            }
            return this.httpService.post(request);
        }
    
        downloadSh2File(id, type) {
            var token = localStorage.getItem('token')
            window.location.href = environment.pssServerUrl + "sh2/downloadDocument/" + id + "/" + type + "/" + token;
        }
        downloadSh2PdfFile(id, type) {
            var token = localStorage.getItem('token')
            window.location.href = environment.pssServerUrl + "sh2/downloadPdfDocument/" + id + "/" + type + "/" + token;
        }

        }